export const isSponsored = buzz => buzz?.bylines?.length && buzz.bylines.some(byline => byline?.title === 'Brand Publisher');
